/* eslint-disable react/prop-types */
import React from 'react';

import '../../assets/scss/components/post/post.scss';

function PostUserInvited({post, profile}) {
  if (!post.memberInvited || !post.members) {
    return null;
  }
  const text = [];

  Object.keys(post.members || {}).forEach(uid => {
    // An invitee's record can't be read until they accept, so this is the name they were invited with. Leave them out if there's none.
    const firstname = profile?.team[uid]?.firstname;
    // eslint-disable-next-line fp/no-mutating-methods
    if (firstname) text.push(firstname);
  });

  if (!text.length) return null;

  return (
    <div className="complete__container complete__container--invite">
      <div className="complete__message">
        <h4 className="complete__name">Hi {text.join(', ')}! 👋</h4>
      </div>
    </div>
  );
}

export default PostUserInvited;
